"use client";

import { useLanguage } from "@/contexts/LanguageContext";
import { useEffect } from "react";

export default function LanguageScript() {
  const { language } = useLanguage();

  useEffect(() => {
    // Get the HTML element
    const htmlElement = document.documentElement;
    
    // Set language attribute
    htmlElement.setAttribute("lang", language);
    
    // No cambiamos la dirección del texto, siempre LTR
    htmlElement.setAttribute("dir", "ltr");
    
  }, [language]);

  // This component doesn't render anything
  return null;
} 